import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Loader } from '@googlemaps/js-api-loader';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {

  private loadPromise: Promise<void> | null = null;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  loadScript(apiKey: string): Promise<void> {
    // Skip during server-side rendering
    if (!isPlatformBrowser(this.platformId)) {
      return Promise.resolve();
    }

    if (this.loadPromise) {
      return this.loadPromise;
    }

    const loader = new Loader({
      apiKey,
      libraries: ['places']
    });

    this.loadPromise = loader.load().then(() => void 0);
    return this.loadPromise;
  }
}
